module.exports = __webpack_public_path__ + "static/aurora-4148d29a3624d3909e674aca90ea576f.png";